import { AsideButton } from './AsideButton';
import { AsideBlock } from './AsideBlock';

export const asideBlockPlugin = {
  type: 'aside',
  buttonComponent: AsideButton,
  blockComponent: AsideBlock,
};
